<template>
   <div>
        <v-skeleton-loader 
            v-for="(i,index) in count" 
            :key="index"
            type="text"
            class="mt-3">
        </v-skeleton-loader>
   </div>
</template>
<script>
export default {
    name: "RadioSkeleton",
    props:{
        count :{
            type : Number,
            default: 1
        }
    }
}
</script>